import { render, staticRenderFns } from "./pdfViewerBlock.vue?vue&type=template&id=2673876a&scoped=true"
import script from "./pdfViewerBlock.vue?vue&type=script&lang=js"
export * from "./pdfViewerBlock.vue?vue&type=script&lang=js"
import style0 from "./pdfViewerBlock.vue?vue&type=style&index=0&id=2673876a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673876a",
  null
  
)

export default component.exports